'use strict';

var _ = require('underscore');
var Collection = require('js/lib/collection');
var Post = require('js/models/post');
var Members = require('js/collections/members');
var Communities = require('js/collections/communities');
var Api = require('js/api');
var config = require('js/config');
var React = require('react');

/**
 * Posts
 * @exports Posts
 * @constructor
 * @alias module:collections/posts
 */
var Posts = Collection.extend({
  model: Post,
  url: config.build.apiPath + '/api/posts',
  topPostsUrl: config.build.apiPath + '/api/top-posts',
  total: 0,
  errorMessage: '',
  dataCacheMap: {
    users: Members,
    groups: Communities,
  },
  initialize: function() {
    this.on('error', () => {
      this.errorMessage = <span>{i18n('Unable to load posts')}, <a onClick={this.refreshOnError.bind(this)}>{i18n('please click here to try again')}</a>.</span>;
    });
      // Call super
    Posts.__super__.initialize.apply(this, arguments);
  },
});

Posts.prototype.refreshOnError = function(event) {
  event.preventDefault();
  this.fetch();
  this.errorMessage = '';
};

/**
 * Parse response payload from api
 */
Posts.prototype.parse = function(response, options) {
  // Store total
  this.total = response.total || 0;

  // We have a posts field but no cached users field, let's build it
  // This is needed for the followedPostsUrl endpoint
  if (response.posts && !response.users) {
    response.users = [];

    for (var i = 0; i < response.posts.length; i++) {
      var user = response.posts[i].author;

      if (!_.findWhere(response.users, {id: user.id})) {
        user.userId = user.id;
        response.users.push(user);
      }
    }
  }

  // Keep data cache up-to-date
  this.ensureDataCache(response, this.dataCacheMap, {accumulate: true});

  const posts = this.parseCollection(response.posts || [], options);
  if (response.ratings) {
    posts.forEach(post => {
      post.ratings = response.ratings;
    });
  }

  return posts;
};

/**
 * Fetch drafts
 */
Posts.prototype.fetchDrafts = function() {
  return this.desc('isDraft', true).fetch();
};

/**
 * Fetch popular
 */
Posts.prototype.fetchPopular = function() {
  return this.desc('sort', 'popular').fetch();
};

/**
 * Fetch popular
 */
Posts.prototype.fetchTop = function() {
  return this.fetch({
    url: this.topPostsUrl,
  });
};

/**
 * Fetch pinned
 */
Posts.prototype.fetchPinned = function() {
  return this.desc('isPinned', true).fetch();
};

/**
 * Fetch filtered by category
 */
Posts.prototype.fetchWithFilter = function(category, sort, pageNumber) {
  this.desc('pageNumber', pageNumber)
    .desc('sort', sort)
    .desc('categoryFilter', category)
    .fetch();
};

/**
 * Sync ratings data as this has to be fetched separately for cached content
 */
Posts.prototype.syncRatings = function() {
  var ids = this.pluck('id');

  // Make a request to fetch cached profile images for given usernames
  return Api.request(config.build.apiPath + '/api/ratings', {
    data: {ids},
  }).then(function(response) {
    var ratings = response.ratings; // post id : numRatings

    // Update ratings for all our posts
    _.each(ratings, function(rating, id) {
      var post = this.get(id);
      if (post) {
        post.set('rating', parseInt(rating));
      }
    }, this);

    // Forward ratings map through promise payload
    return ratings;
  }, this);
};

/**
 * Sync pinned post order by sending it back to the api
 */
Posts.prototype.syncPinnedOrder = function() {

  // create object array to send
  var pinnedTotal = this.models.length;
  var pinOrder = _.map(this.models, function(model, i) {
    return {
      postId: model.id,
      sortOrder: pinnedTotal - i,
    };
  });

  //then post it to api
  return Api.put(config.build.apiPath + '/api/posts/pin/order', {
    data: {groupCode: this.description.groupCode, postOrder: pinOrder},
  });
};

module.exports = Posts;



// WEBPACK FOOTER //
// ./app/assets/js/collections/posts.js